export default __webpack_public_path__ + "static/media/element_banner_sale.65c90863.png";